import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Trace = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M3.837 13H0v-2h2.026A10.228 10.228 0 0 1 4.91 4.844a10.032 10.032 0 0 1 6.13-2.938L11.096 0h1.998l-.053 3.73c-3.113 0-5.42.737-7.365 3.273l5.352-.04a.99.99 0 0 1 .993.992c0 .55-.443 1.006-.993 1.006l-6.48.04c-.63 1.597-.71 2.348-.71 3.998Zm18.245 0a10.18 10.18 0 0 1-2.844 6.13 9.956 9.956 0 0 1-6.198 2.965V24h-1.986l-.027-3.73c3.166 0 5.447-.697 7.42-3.273h-5.448c-.55 0-1.006-.442-1.006-.992 0-.564.456-1.007 1.006-1.007h6.574c.617-1.556.684-2.388.684-3.984l3.73.04.013 2-1.918-.055ZM7.996 11h7.968v2H7.996v-2Z"
      fill="currentColor"
    />
  </Icon>
));

export default Trace;
